export default __webpack_public_path__ + "static/media/logo-gobolt-primary-icon.ce672319.svg";